const HowToUseApp = [
    {
        id:1,
        title: 'Sign in',
        info: 'lorem ipsum info',
    },
    {
        id:2,
        title: 'Add your bank account',
        info: 'lorem ipsum info',
    },
    {
        id:3,
        title: 'Send payment request',
        info: 'lorem ipsum info',
    },
];

export default HowToUseApp;